import { FC } from "react";

export interface BtnPartageIconProps {
  className?: string;
  colorClass?: string;
  onClick?: () => void; 
}

const BtnPartageIcon: FC<BtnPartageIconProps> = ({
  className = "",
  colorClass = "text-white",
  onClick
}) => {

  return (
    <div
      className={`nc-voyagBtnPartageVoyageIcon flex items-center justify-center rounded-full cursor-pointer ${colorClass} ${className} `}
      data-nc-id="BtnPartageIcon"
      title="Partager"
      onClick={onClick}
    ><i className={`p-1 text-xl las la-share`}></i>
    </div>
  );
};

export default BtnPartageIcon;
